import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom"; // Import useNavigate here
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Forget from "./pages/Forget";
import MainComponent from "./pages/MainComponent";
import MaintenancePage from "./components/MaintenancePage";
import AdminMaintenance from "./components/AdminMaintenance";
import { MAINTENANCE_MODE } from "./pages/config";
//import { detectIncognito } from "detect-incognito";  // Import detectIncognito
import { signInAnon } from "./services/firebaseAuthService";  // Import signInAnon
//import usePrivateBrowsingCheck from "./hooks/usePrivateBrowsingCheck";  // Import custom hook
import ProtectedAnonRoute from "./components/ProtectedAnonRoute";

function App() {
  const { currentUser } = useAuth();

  // Use the custom hook to check for private browsing on app mount
  // This is now wrapped inside the Router context
  return (
    <Router>
        <Routes>
          {/* Redirect root path to /chat */}
          <Route path="/" element={<Navigate to="/chat" />} />
          <Route path="" element={<Navigate to="/chat" />} />

          {/* MainComponent route */}
          <Route path="/chat" element={<ProtectedAnonRoute><MainComponent /></ProtectedAnonRoute>} />

          {/* Register route */}
          <Route path="/register" element={<Register />} />

          {/* Forget password route */}
          <Route path="/forget" element={<Forget />} />

          {/* Login route */}
          <Route path="/login" element={<Login />} />

          {/* Admin route */}
          <Route path="/admin/maintenance" element={<AdminMaintenance />} />
        </Routes>

        {/* Now we can safely use usePrivateBrowsingCheck within the Router */}
        {/* <CheckPrivateBrowsing /> */}  {/* This uses the custom hook safely inside Router */}
    </Router>
  );
}

// const CheckPrivateBrowsing = () => {
//   const { currentUser } = useAuth();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkPrivateBrowsing = async () => {
//       try {
//         const result = await detectIncognito();
//         if (result.isPrivate && !currentUser) {
//           // Sign in anonymously if in private mode and no user is signed in
//           const anonResult = await signInAnon();
//           if (anonResult.user) {
//             navigate("/chat"); // Redirect after successful sign-in
//           }
//         }
//       } catch (error) {
//         console.error("Error detecting private browsing mode:", error);
//         // Optionally show an error message to the user
//       }
//     };

//     checkPrivateBrowsing();
//   }, [currentUser, navigate]);

//   return null;  // No UI for this component, just running the logic
// };

export default App;
